module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="day">\n  ';
 if (legislative_day) { 
__p+='\n    <span class="legislative-day leg-day day-label"><h4>Legislative Day '+
((__t=( legislative_day ))==null?'':__t)+
'</h4></span>\n    <span class="legislative_date">'+
((__t=(  legislative_day_date ))==null?'':_.escape(__t))+
'</span>\n  ';
 } else { 
__p+='\n    <span class="non-leg-day day-label"> </span>\n   ';
 } 
__p+='\n   <!-- <h5 class="sans">'+
((__t=( legislative_day_date ))==null?'':__t)+
'</h5> -->\n</div>';
}
return __p;
};
